import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addMemberToRoom, getRoomRequests, manageSocialRoom } from '../../../../actions/userActions';
import AdminRoomRequests from '../../../../containers/ChatRooms/Room/Admin/Room/AdminRoomRequest';
import { useTokenCallback } from '../../../../utils/hooks/useTokenCallback';

const AdminRequestRoom = ({ match }) => {
  const { roomRequests } = useSelector(state => state.userInfo)
  const dispatch = useDispatch()
  useTokenCallback(() => {
    dispatch(getRoomRequests(match.params.idRoom))
  }, [match.params.idRoom])
  const accept = (id,member)=>{
    dispatch(manageSocialRoom({
      chatRoomID: match.params.idRoom,
      entityID: id,
      type: 2
    },member,"roomRequest"))
  }
  const reject = (id,member)=>{
    dispatch(manageSocialRoom({
      chatRoomID: match.params.idRoom,
      entityID: id,
      type: 3
    },member,"roomRequest"))
  }
  return <AdminRoomRequests accept={accept} reject={reject} requests={roomRequests}/>
};

export default AdminRequestRoom;
